import { useEffect, useState } from "react";
import { useGetPermissions } from "react-admin";

import { UserRole } from "../types/user.types";
import useCurrentUser from "./useCurrentUser";

const useIsGym = () => {
  const { user } = useCurrentUser();
  const [isGym, setIsGym] = useState(user.role === UserRole.gym);
  const perms = useGetPermissions();

  useEffect(() => {
    (async function () {
      const permissions = await perms();
      if (permissions) {
        const role = permissions && permissions.role;
        setIsGym(role === UserRole.gym);
      }
    })();
  }, [perms, user.id]);

  return { isGym };
};

export default useIsGym;
